import React, { FC, useCallback, useMemo } from 'react'

import { ReportCardCancellationSteps, useReportCardCancellationModalContext } from '../ReportCardCancellationModalContext'
import { Button, Checkbox } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import { IconPosition, PaymentMethodRow } from '../../PaymentMethodRow'
import { maskCreditCardNumber } from '../../../utils/card'

const I18N_NAMESPACE = ['account']

export const SelectCard: FC = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { creditCards, selectedCardIds, setSelectedCardIds, setStep } = useReportCardCancellationModalContext()

  const submitDisabled = useMemo(() => {
    return selectedCardIds.length === 0
  }, [selectedCardIds.length])

  const cardSelectHandler = useCallback(
    (id: number) => {
      if (selectedCardIds.includes(id)) {
        const dummy = [...selectedCardIds]
        dummy.splice(selectedCardIds.indexOf(id), 1)
        setSelectedCardIds([...dummy])
      } else {
        setSelectedCardIds([...selectedCardIds, id])
      }
    },
    [setSelectedCardIds, selectedCardIds]
  )
  const submitHandler = useCallback(() => {
    setStep(ReportCardCancellationSteps.Confirm)
  }, [setStep])

  return (
    <>
      <div className='max-h-[35vh] overflow-y-auto'>
        <div className='border-dark-subtle rounded-sm border border-solid'>
          {creditCards.map((card, index) => {
            return (
              <div
                key={card.id}
                className={`alignCenter flex px-4 py-5 ${
                  index === creditCards.length - 1 ? '' : 'border-dark-subtle border-x-0 border-b border-t-0 border-solid'
                }`}
              >
                <Checkbox defaultChecked={selectedCardIds.includes(card.id)} onChange={() => cardSelectHandler(card.id)} />
                <div className='flex-auto'>
                  <PaymentMethodRow
                    number={maskCreditCardNumber(card.truncatedNumber ?? card.maskedPan)}
                    expiryDate={card.expiryDate}
                    cardType={card.cardBrand}
                    iconPosition={IconPosition.Right}
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className='mt-6'>
        <Button padding='Fluid' disabled={submitDisabled} onClick={submitHandler}>
          {t('account:tab:payment-methods:reportCardCancellationModal:cta:selectCard')}
        </Button>
      </div>
    </>
  )
}
